import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedDelete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 49,
	viewBox: "0 0 48 49",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.1045 42.3125C13.016 42.3125 12.0841 41.9249 11.3089 41.1497C10.5337 40.3746 10.1462 39.4427 10.1462 38.3542V12.625H8.16699V8.66667H18.0628V6.6875H29.9378V8.66667H39.8337V12.625H37.8545V38.3542C37.8545 39.4427 37.4669 40.3746 36.6917 41.1497C35.9166 41.9249 34.9847 42.3125 33.8962 42.3125H14.1045ZM18.0628 34.3958H22.0212V16.5833H18.0628V34.3958ZM25.9795 34.3958H29.9378V16.5833H25.9795V34.3958Z",
		fill: "url(#paint0_linear_1355_7285)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_1355_7285",
		x1: 8.00037,
		y1: 42.7813,
		x2: 47.8294,
		y2: 19.769,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedDelete;
